import * as React from 'react';

import { IMarkedListItem } from '../../../common/types/listingOffers';
import { Section } from '../Section';
import * as styles from './SeoMarkedList.css';
import { SeoMarkedListItem } from './components/SeoMarkedListItem';

interface ISeoMarkedListProps {
  items: IMarkedListItem[];
}

export const SeoMarkedList: React.VFC<ISeoMarkedListProps> = ({ items }) => (
  <Section className={styles['container']}>
    {items.map((item, index) => {
      const id = `SeoMarkedListItem_${index}`;

      return <SeoMarkedListItem key={id} id={id} {...item} />;
    })}
  </Section>
);
